/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoadmapResourceRowDto
 */
export interface RoadmapResourceRowDto {
    /**
     * 
     * @type {string}
     * @memberof RoadmapResourceRowDto
     */
    resourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapResourceRowDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapResourceRowDto
     */
    userId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RoadmapResourceRowDto
     */
    unassignedLabor?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof RoadmapResourceRowDto
     */
    laborHoursLogged?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof RoadmapResourceRowDto
     */
    laborHoursCapacity?: Array<number>;
}

/**
 * Check if a given object implements the RoadmapResourceRowDto interface.
 */
export function instanceOfRoadmapResourceRowDto(value: object): value is RoadmapResourceRowDto {
    return true;
}

export function RoadmapResourceRowDtoFromJSON(json: any): RoadmapResourceRowDto {
    return RoadmapResourceRowDtoFromJSONTyped(json, false);
}

export function RoadmapResourceRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoadmapResourceRowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'resourceId': json['resourceId'] == null ? undefined : json['resourceId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'unassignedLabor': json['unassignedLabor'] == null ? undefined : json['unassignedLabor'],
        'laborHoursLogged': json['laborHoursLogged'] == null ? undefined : json['laborHoursLogged'],
        'laborHoursCapacity': json['laborHoursCapacity'] == null ? undefined : json['laborHoursCapacity'],
    };
}

export function RoadmapResourceRowDtoToJSON(json: any): RoadmapResourceRowDto {
    return RoadmapResourceRowDtoToJSONTyped(json, false);
}

export function RoadmapResourceRowDtoToJSONTyped(value?: RoadmapResourceRowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resourceId': value['resourceId'],
        'displayName': value['displayName'],
        'userId': value['userId'],
        'unassignedLabor': value['unassignedLabor'],
        'laborHoursLogged': value['laborHoursLogged'],
        'laborHoursCapacity': value['laborHoursCapacity'],
    };
}

